/** Papéis de membro (espelham o enum MembershipRole do backend). */
export const MEMBER_ROLES = ['Owner', 'Administrator', 'Supervisor', 'Agent', 'Analyst'] as const

export type MemberRole = (typeof MEMBER_ROLES)[number]

/** Membro da equipe, já com nome/e-mail (GET /members). */
export interface TeamMember {
  readonly id: string
  readonly userId: string
  readonly role: string
  readonly status: string
  readonly displayName: string
  readonly email: string | null
}

/** Convite pendente (GET /invitations) — nunca inclui o token. */
export interface PendingInvitation {
  readonly id: string
  readonly email: string
  readonly role: string
  readonly createdAt: string
  readonly expiresAt: string
  readonly expired: boolean
}

/** Retorno da criação de convite: token + link em claro UMA vez. */
export interface CreatedInvitation {
  readonly id: string
  readonly email: string
  readonly role: string
  readonly expiresAt: string
  readonly token: string
  readonly inviteLink: string
}

/** Retorno do aceite. */
export interface AcceptedInvitation {
  readonly tenantSlug: string
  readonly alreadyMember: boolean
}
